import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LegalShell, LegalLead, LegalH2, LegalP, LegalLastUpdated } from './LegalPages';

export function DpaPage() {
  const { t } = useTranslation();
  return (
    <LegalShell titleKey="dpa.title">
      <LegalLead>{t('dpa.lead')}</LegalLead>

      <LegalH2>{t('dpa.roles_title')}</LegalH2>
      <LegalP>{t('dpa.roles_body')}</LegalP>

      <LegalH2>{t('dpa.subject_title')}</LegalH2>
      <LegalP>{t('dpa.subject_body')}</LegalP>

      <LegalH2>{t('dpa.categories_title')}</LegalH2>
      <LegalP>{t('dpa.categories_body')}</LegalP>

      <LegalH2>{t('dpa.subprocessors_title')}</LegalH2>
      <LegalP>
        {t('dpa.subprocessors_body_prefix')}{' '}
        <Link to="/subprocessors" className="text-accent-700 hover:text-accent-600 underline underline-offset-2">
          patronez.com/subprocessors
        </Link>{' '}
        {t('dpa.subprocessors_body_suffix')}
      </LegalP>

      <LegalH2>{t('dpa.transfers_title')}</LegalH2>
      <LegalP>{t('dpa.transfers_body')}</LegalP>

      <LegalH2>{t('dpa.rights_title')}</LegalH2>
      <LegalP>{t('dpa.rights_body')}</LegalP>

      <LegalH2>{t('dpa.security_title')}</LegalH2>
      <LegalP>
        {t('dpa.security_body_prefix')}{' '}
        <Link to="/security" className="text-accent-700 hover:text-accent-600 underline underline-offset-2">
          patronez.com/security
        </Link>{' '}
        {t('dpa.security_body_suffix')}
      </LegalP>

      <LegalH2>{t('dpa.breach_title')}</LegalH2>
      <LegalP>{t('dpa.breach_body')}</LegalP>

      <LegalH2>{t('dpa.signature_title')}</LegalH2>
      <LegalP>{t('dpa.signature_body')}</LegalP>

      <LegalLastUpdated>{t('dpa.last_updated')}</LegalLastUpdated>
    </LegalShell>
  );
}
